import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMetadata, structuredData } from './metadata';

const updateMeta = (key, value, property = false) => {
  const attribute = property ? 'property' : 'name';
  let node = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (value == null) { node?.remove(); return; }
  if (!node) { node = document.createElement('meta'); node.setAttribute(attribute, key); document.head.appendChild(node); }
  node.setAttribute('content', value);
};

export const RouteMetadata = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = getMetadata(pathname);
    document.title = m.title;
    updateMeta('description', m.description);
    updateMeta('robots', m.robots);
    ['title', 'description', 'image'].forEach((field) => {
      updateMeta(`og:${field}`, m[field], true);
      updateMeta(`twitter:${field}`, m[field]);
    });
    updateMeta('og:url', m.canonical, true);
    updateMeta('twitter:url', m.canonical);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (m.canonical) {
      if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
      canonical.href = m.canonical;
    } else canonical?.remove();
    let schema = document.getElementById('hbk-schema');
    if (!schema) { schema = document.createElement('script'); schema.id = 'hbk-schema'; schema.type = 'application/ld+json'; document.head.appendChild(schema); }
    schema.textContent = JSON.stringify(structuredData(pathname));
  }, [pathname]);
  return null;
};